var $ = require('jquery');

$(document).on('click', '.has-hover-toggle', function() {
    $(this).toggleClass('hover');
 });

$(function(){
    // Removes the no-touch class from the devices Modernizr does not detect
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Touch|Tablet/i.test(navigator.userAgent);
    if (isMobile) {
        $('html').removeClass('no-touch');
    }
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/hover.js
// module id = 22
// module chunks = 0